// extracted by mini-css-extract-plugin
module.exports = {"icon":"select_icon__1TxWi","open":"select_open__ZXqvG"};